module.exports = __webpack_public_path__ + "static/media/extreme.4b962a8b.svg";